// config.js
const config = {
    // apiUrl: 'http://localhost:3001',
    apiUrl: 'https://nurg25.kz:3001',
   
    nameCargo: 'НУР КАРГО'
  };
  
  
export default config;
